import { keysToLowerCase, checkTranslationRegex, getDateFormatString } from '/src/common/general-utils';

const checkAppPermissions = (userAreas, area) => {
  // Backward compatibility checking for both App. and App:

  //If app name is translated
  const isTranslationStr = checkTranslationRegex(area.substring(4));
  let dbString;
  if (area.indexOf('.dashboard') !== -1) {
    const appName = area.substring(area.indexOf('app.') + 4, area.indexOf('.dashboard.'));
    const dashboardName = area.substring(area.indexOf('.dashboard.') + 11);
    dbString = ['app', appName, 'dashboard', dashboardName];
  }
  if (isTranslationStr) {
    return (
      userAreas[area.substring(0, 3)] ||
      userAreas[area.substring(0, 3) + '.' + area.substring(4)] ||
      userAreas[area.substring(0, 3) + ':' + area.substring(4)] ||
      (!!dbString && userAreas[dbString.join('.')])
    );
  }

  // When app name is not translated
  let splitted = area.split(area[3]);
  return (
    userAreas[splitted[0]] ||
    userAreas[splitted[0] + '.' + splitted[1]] ||
    userAreas[splitted[0] + ':' + splitted[1]] ||
    (!!dbString && userAreas[dbString.join('.')])
  );
};

const checkPermissions = (userAreas, area) => {
  let splittedArea = area.split('.');
  let search = splittedArea[0];
  for (let index = 0; index < splittedArea.length; index++) {
    if (userAreas[search] && search !== 'object') {
      return true;
    } else if (index < splittedArea.length - 1) {
      search += '.' + splittedArea[index + 1];
    }
  }
  return false;
};

export const entityList = (state) => state.entity?.list || [];

export const entityFlattenList = (state) => state.entity?.flattenList || [];

export const userAreas = (state) => state['user-login'].user.areas;

export const userDetails = (state) => state['user-login'].user;

export const themeDetails = (state) => state['user-login'].theme;

export const breadcrumbs = (state) => state.breadcrumbs;

export const userID = (state) => state['user-login'].user.ID;

export const ListDelegatedToCurrentUser = (state) => state.ListDelegatedToCurrentUser;

export const selectedEntity = (state) => state.entity.selected;

export const getSystemVariable = (state) => (key) =>
  state['admin/system-variable'].systemVariableMap[key.toLowerCase()];

//returns the boolean value to identify whether the feature should be displayed
//it depends on the system variable set correctly
//NOTE: Only use 'yes'/'no' for the value.
export const showFeature = (state, getters) => (key) => {
  let value = getters.getSystemVariable(key);
  return value && value.toLowerCase() === 'yes';
};
export const showFeatureUser = (state) => (key, isBoolean) => {
  if (state['user-login']?.user?.platFormSettings) {
    let value = state['user-login'].user.platFormSettings[key.toUpperCase()];
    if (isBoolean) {
      return (value && value.toString().toLowerCase() === 'yes') || value === true;
    }
    return value;
  }
  return undefined;
};

export const getLanguageByUUID = (state) => (UUID) =>
  state.availableLanguages.find((language) => language.UUID === UUID);

export const baseLanguage = (state) => state.availableLanguages.find((language) => language.IsBase);

//TODO: Revise after consulting development team regarding caching

export const isAuthorised = (state) => (area) => {
  let areasToSkip = ['access', 'applications', 'system', 'object.', 'app.'];
  if (
    state['user-login'].user?.areas?.all ||
    (area && state['user-login'].user?.areas?.admin && !areasToSkip.some((el) => area.startsWith(el)))
  ) {
    return true;
  }
  return state['user-login'].user.areas && state['user-login'].user.areas[area];
};
/**
 * To check if user is authorized to see a menu item
 */
export const showMenuItem = (state, getters) => (area) => {
  let areas = keysToLowerCase(getters.userAreas);
  let areaKeys = Object.keys(areas);

  // Can be removed later when we do not support multiple authorization keys on a menu
  if (Array.isArray(area)) {
    area = area.map((i) => i.toLowerCase());
    return areaKeys.find((i) => i.includes('all') || area.includes(i.split('.')[0]) || area.includes(i));
  }

  if (!area && areas['all']) {
    return true;
  } else if (!area) {
    return false;
  }

  area = area.toLowerCase();

  if (
    areas['all'] ||
    (areas['admin'] && !area.startsWith('access') && !area.startsWith('applications') && !area.startsWith('system'))
  ) {
    return true;
  } else if (area.includes('.')) {
    return area.split('.').some((value, index, splittedArray) => {
      const search = splittedArray.slice(0, index + 1).join('.');
      return search !== 'object' && areas[search];
    });
  }
  return areaKeys.find((key) => key.startsWith(area));
};

export const hasAccess = (state, getters) => (areas, checkForSubstr) =>
  areas.some((area) => getters.accessHelper(area, checkForSubstr));

export const hasAllAccess = (state, getters) => (areas, checkForSubstr) =>
  areas.every((area) => getters.accessHelper(area, checkForSubstr));

export const applyAccessFilter = (state, getters) => (list) =>
  list.filter(({ accessKeys }) => (accessKeys && accessKeys.length ? getters.hasAccess(accessKeys) : true));

export const isAuthorized = (state, getters) => (area, checkForSubstr) => {
  area = area.toLowerCase();
  let userAreas = keysToLowerCase(getters.userAreas);
  let areaKeys = Object.keys(userAreas).filter((a) => a);

  // User with all key has access to every functionality of Sofy
  if (userAreas['all']) {
    return true;
  }

  if (checkForSubstr) {
    /* Check if the areaName is substring of any of the available keys
     *  for this case
     *  if group or user has some fields authorization for edit and add
     *  then also he should be called authorized for edit.
     */
    for (let key of areaKeys) {
      if (userAreas[key] && key.indexOf(area + '.') === 0) {
        return true;
      }
    }
  }

  if (area.indexOf('app.') === 0 || area.indexOf('app:') === 0) {
    return checkAppPermissions(userAreas, area);
  }

  const isAuthorized = checkPermissions(userAreas, area);
  if (isAuthorized) {
    return true;
  }

  /**
   * When 'object' key is added in authorization, it has access to all objects.
   * So returning true if area relate to object and key is defined.
   */
  return !!(area.indexOf('object.') === 0 && userAreas['object']);
};

export const accessHelper = (state, getters) => (area, checkForSubstr) => {
  let authorized = getters.isAuthorized(area, checkForSubstr);
  if (!authorized && area.endsWith('.Read')) {
    authorized = getters.isAuthorized(area.substring(0, area.indexOf('.Read')), true);
  }
  return authorized;
};

export const shouldShowInbox = (state, getters) => {
  let isInboxDisabled = getters.showFeatureUser('DISABLE_INBOX_BUTTON', true);
  return !isInboxDisabled && getters.hasAccess(['User']);
};

/**
 * Check if the user has access to create/update the record
 */
export const hasRecordSaveAccess = (state, getters) => (recordAuthorization, hasRecordUUID) => {
  const { defaultUIAuth } = (recordAuthorization || '{}').sParseJSON();
  const authKey = defaultUIAuth ? defaultUIAuth.trim() : null;
  return !(authKey && !getters.hasAccess([`${authKey}.${hasRecordUUID ? 'Edit' : 'Create'}`], true));
};

export const dateFormatString = (state) => getDateFormatString(state['user-login'].user);

export const shouldShowQuickLinks = (state, getters) => {
  const showQuickLinks = getters.showFeatureUser('ENABLE_QUICK_LINKS', true); // for quick links feature disabled from TM
  const isQuickLinksDisabled = (state['user-login'].user && state['user-login'].user.DisableQuicklinks) !== true; // for quick links feature disabled by user.

  return !!showQuickLinks && getters.hasAccess(['User']) && isQuickLinksDisabled;
};

export const getFileUploadProgress = (state) => (key) => state.progress[key];
